<template>
  <div>
    <custom-callout
      :has-toggle="false"
      border-color="gray"
      class-main="p-2 pb-3"
      class="mt-2"
    >
      <div class="row">
        <div class="col-12 pl-2">
          <div class="row">
            <div class="col-md-2 col-6 pt-0">
              <div>
                <div class="row">
                  <div class="col-12 pt-0">
                    <span class="title-label">Año académico:</span>
                    <div class="regular info-label">
                      {{ item.academicYearDescription | empty }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2 col-6 pt-0">
              <div>
                <div class="row">
                  <div class="col-12 pt-0">
                    <span class="title-label">Área:</span>
                    <div class="regular info-label">
                      {{ item.area }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2 col-6 pt-0">
              <div>
                <div class="row">
                  <div class="col-12 pt-0">
                    <span class="title-label">Grado:</span>
                    <div class="regular info-label">
                      {{ item.grade }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-md-4 col-6 pt-0">
              <div>
                <div class="row">
                  <div class="col-12 pt-0">
                    <span class="title-label">Detalle de la destreza:</span>
                    <div class="regular info-label">
                      {{ item.description }}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-2 col-6 pt-0" v-if="!item.activeFlag">
              <div>
                <div class="row">
                  <div class="col-12 pt-0">
                    <span class="title-label">Razón de Inactivación:</span>
                    <div class="regular info-label">
                      {{ item.inactivationReason }}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="col-12 col-md-2 mt-2 mt-md-0 d-md-flex justify-content-end align-items-center"
              v-if="item.activeFlag"
            >
              <div class="text-right">
                <div class="dropdown">
                  <action-button
                    class="btn btn-dropdown-actions dropdown-toggle pt-1"
                    type="button"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Acciones
                  </action-button>
                  <div class="dropdown-menu dropdown-menu-right">
                    <action-button
                      type="button"
                      class="dropdown-item cursor-pointer text-left"
                      i="fas fa-ban fa-fw text-red mr-2"
                      id="inactiveBtn"
                      @click="() => this.handleShowInactivePanel()"
                      text="Inactivar"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </custom-callout>
    <template v-if="inactivationPanelOpen">
      <div class="bg-light-gray rounded pt-1 pl-2 pr-2 pb-2">
        <div class="bg-white rounded mt-1 p-4">
          <div class="row">
            <div class="col-12 pt-1 pt-lg-0">
              <span class="title d-flex align-items-center">
                <div class="circle-icon d-flex">
                  <span class="fa-stack fa-1x">
                    <i class="fas fa-circle fa-stack-2x text-white" />
                    <i class="fas fa-ban fa-stack-1x text-danger" />
                  </span>
                </div>
                <span class="ml-2 dark-gray font-weight-bolder">Inactivar</span>
              </span>
            </div>
          </div>
          <ValidationObserver ref="form">
            <div class="row py-2">
              <div class="col-12 mt-2">
                <ValidationProvider
                  v-slot="{ errors }"
                  mode="eager"
                  rules="required"
                >
                  <custom-text-area
                    v-model="model.reason"
                    :clearable="false"
                    custom-error-msg="La razón es requerida."
                    :error="errors[0]"
                    label="Razón de inactivación:"
                    :maxlength="3000"
                    show-char-count
                    :count-classes="['d-block text-right']"
                    :rows="2"
                  />
                </ValidationProvider>
              </div>
              <div class="col-12 mt-3 d-flex justify-content-end">
                <action-button
                  class="ml-2 px-4 mb-3"
                  variant="outline-danger"
                  i="fas fa-times-circle"
                  text="Cancelar"
                  @click="inactivationPanelOpen = false"
                />
                <action-button
                  type="button"
                  text="Guardar"
                  i="fas fa-save"
                  variant="success"
                  class="ml-2 px-4 mb-3"
                  @click="handleSaveInactivation()"
                />
              </div>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CustomCallout from "custom-callout";
import ActionButton from "ActionButton";
import CustomTextArea from "CustomTextArea";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import mixAlert from "@/mixin/alert.mixin";

export default {
  name: "ResultRow",
  components: {
    CustomCallout,
    ActionButton,
    CustomTextArea,
    ValidationProvider,
    ValidationObserver
  },
  mixins: [mixAlert],
  data: () => ({
    inactivationPanelOpen: false,
    model: {
      reason: null
    }
  }),
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    handleShowInactivePanel() {
      this.inactivationPanelOpen = true;
      this.model.reason = null;
    },
    async handleSaveInactivation() {
      const isValid = await this.$refs.form.validate();
      if (!isValid) {
        this.ShowToast("Alerta", "Información Incompleta", "error");
        return;
      }

      const payload = {
        skillId: this.item.id,
        inactivationReason: this.model.reason
      };

      this.inactivationPanelOpen = false;

      this.$emit("on-save-inactivation", payload);
    }
  }
};
</script>

<style scoped>
.circle-icon {
  box-shadow: 0px 3px 6px #00000029;
  width: 35px;
  border-radius: 35px;
}

.title-label {
  font-size: 14px;
  color: #727272;
}

.info-label {
  color: #11291b;
}
</style>
